export default __webpack_public_path__ + "static/media/app-bar-logo.8d4fb697.svg";